import { JarvisAuthProvider, JarvisWebHttpClient } from '@jarvis/web-http';
import getCommonsNorthboundAPIs from '../contexts/dependencyManager/utils/getCommonsNorthboundAPIs';

export const jarvisHttpClient = (): {
  httpClient: JarvisWebHttpClient;
  defaultHeaders: Record<string, string>;
} => {
  const { v1 } = getCommonsNorthboundAPIs();
  const authProvider = v1?.authProvider as JarvisAuthProvider;

  const defaultHeaders = {
    'Content-Type': 'application/vnd.api+json'
  };

  const httpClient = new JarvisWebHttpClient({
    defaultAuthProvider: authProvider,
    defaultRetries: 1
  });

  return { httpClient, defaultHeaders };
};
